<template>
  <div>
    <!-- <navigation adaption/> -->
    <div class="page face-authentication">
      <div class="background">
        <img class="back" src="./images/back.png" alt="" @click="back">
        <p class="title">身份验证</p>
      </div>

      <div class="authentication-step">
        <div class="steps">
          <div class="step-item">
            <i class="custom-icon phone"></i>
            <span>请竖直紧握手机</span>
          </div>

          <div class="step-item">
            <i class="custom-icon face"></i>
            <span>请勿遮挡脸部</span>
          </div>

          <div class="step-item">
            <i class="custom-icon light"></i>
            <span>请在光线良好的环境下做测试</span>
          </div>

          <div class="step-item">
            <i class="custom-icon portrait"></i>
            <span>请将人脸放在人像框内</span>
          </div>
        </div>
        <p class="protocol-container">点击「开始验证」按钮表示您已阅读并同意 <span  @click="routeFaceProtocol">《人脸识别服务用户授权书》</span></p>
        <nd-button class="start-authentication" @click="startAuth" :disabled="false">开始验证</nd-button>
      </div>
    </div>
    <detention v-model="detentionVisible"></detention>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import qs from 'qs'
import { judgeClientSystem, getKey, versionStringCompare, isWxMiniprogram } from '@/assets/utils'
import riverDiversion from './faceStep/riverDiversion'
export default {
  name: 'face-authentication',

  description: '刷脸活体认证',

  customReadyNotify: true,

  computed: {
    ...mapState('user', ['userInfo'])
  },
  components: {
    detention: () => import('./components/detention.vue')
  },

  data () {
    return {
      detentionVisible: false,
      faceSource: this.$storage.get('faceSource'),
      from: this.$route.query.from,
      to: this.$route.query.to,
      step: this.$route.query.step,
      form: {
        faceTerminal: 'H5',
        faceType: 'FACE_ID_CHECK',
        mobileNumber: '',
        deviceIp: '',
        productIdentifier: ''
      },
      sceneType: this.$route.query.sceneType,
      sceneNo: this.$route.query.sceneNo,
      redirectUrl: this.$route.query.redirectUrl,
      query: this.$route.query
    
    }
  },
  mounted () {
    // 走旷世人脸流程
    if (this.isApiH5 && isWxMiniprogram()) {
      this.$router.replace('/authentication/face-mp')
      return 
    }
    if (this.$route.query?.redirectUrl === '/authentication/id-h5-credit') {
      window.history.pushState({}, '', window.location.href)
      window.addEventListener('popstate', () => {
        this.detentionVisible = true
      })
    }
    this.getUserInfoX().then(() => {
      this.$bus.$emit('ready')
      if (this.query.newSignature) {
        this.verifyAuthResult()
      }
    }).catch(() => {
      this.$bus.$emit('error')
    })
  },
  methods: {
    ...mapActions('authentication', [
      'getTencentTokenX',
      'verifyTencetLivenessResultX'
    ]),

    ...mapActions('user', [
      'getUserInfoX'
    ]),

    routeFaceProtocol () {
      const origin = process.env.VUE_APP_PROURL
      window.location.href = `${origin}/protocol/public/face` 
    },
    async startAuth () {
      // 针对颜值贷用户做单独的提示
      const channel = getKey('channel') || this.$route.query.channel || 'official'
      if (judgeClientSystem() === 'Android' && channel === 'H5-YZD') {
        return this.$router.push('/authentication/face-error')
      }
      if (!this.$route.query.signature) {
        this.$storage.set('faceAuthUrl', encodeURIComponent(window.location.href))
      }
      let bool = true
      let faceVersion = ''
      if (judgeClientSystem() !== 'IOS' && hasNativeMethod('openCameraPermission')) {
        if (versionStringCompare('1.7.8.8', getKey('appVersion')) <= 0) {
          faceVersion = 'V2'
        }
        const res = await jsBridge('openCameraPermission', { needCamera: 'Y' })
        if (res.code !== 'OK') {
          bool = false
        }
      } else {
        faceVersion = 'V2'
      }
      if (bool) {
        const params = {
          way: 'H5', faceVersion
        }
        // 从localStorage中获取人脸认证的URL 防止腾讯回来参数丢失
        const faceAuthUrl = decodeURIComponent(this.$storage.get('faceAuthUrl')) || ''
        const { sceneType, sceneNo, redirectUrl } = qs.parse(faceAuthUrl.split('?')[1] || '')
     
        this.redirectUrl = redirectUrl
        this.sceneType = sceneType
        this.sceneNo = sceneNo
        params.redirectUrl = this.redirectUrl || '/middle/limit'
        if (this.sceneType) {
          params.sceneType = this.sceneType
          params.sceneNo = this.sceneNo
        }
        const response = await this.getTencentTokenX({ ...params })
        
        if (response.data.success) {
          if (response.data.data.sign) {
            this.$storage.set('faceSign', response.data.data.sign)
          }
          this.redirectTencent(response.data.data)
        }
      }
    },

    // 跳转腾讯
    redirectTencent (data) {
      const params = {
        webankAppId: data.appId,
        version: '1.0.0',
        nonce: data.nonce,
        orderNo: data.orderNo,
        h5faceId: data.faceId,
        url: this.$storage.get('faceAuthUrl'),
        resultType: '',
        userId: data.userId,
        sign: data.sign,
        from: 'browser',
        redirectType: '1'
      }

      const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
      window.location.href = `${data.faceHost}/api/web/login?${queryString}`
    },

    // 验证结果
    async verifyAuthResult () {
      const params = Object.assign({}, this.form, {
        sign: this.$storage.get('faceSign'),
        tencentSign: this.query.newSignature,
        orderNo: this.query.orderNo
      })
      const response = await this.verifyTencetLivenessResultX(params)
      
      if (response.success) {
        this.$message('活体认证成功')

        const faceAuthUrl = decodeURIComponent(this.$storage.get('faceAuthUrl')) || ''
        const { sceneType, sceneNo, redirectUrl } = qs.parse(faceAuthUrl.split('?')[1] || '')

        this.redirectUrl = redirectUrl
        this.sceneType = sceneType
        this.sceneNo = sceneNo
        params.redirectUrl = this.redirectUrl || '/middle/limit'

        await riverDiversion(this, { redirectUrl }) // 抽离的导流人脸流程

        this.$router.replace({
          path: redirectUrl,
          query: {
            recordNo: this.sceneNo,
            result: 'PASS'
          }
        })
      } else {
        this.$sensors.track('FACE_FAIL', {
          redirectUrl: this.redirectUrl,
          comment: response.msg
        })
        this.$message(response.msg)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

    .face-authentication {
        height: 100vh;
        position: relative;

        .background {
            width: 100%;
            height: 697px;
            background-size: 100% 100%;
            background-image: url(./images/bg.png);
            position: absolute;
            top: 0;
            z-index: 0;
            .back {
                width: 50px;
                height: 50px;
                z-index: 1;
                margin-top: 87px;
                margin-left: 54px;
            }
            .title {
                width: 100%;
                margin-top: 62px;
                color: white;
                font-size: 74px;
                font-weight: 300;
                padding-left: 56px;
            }
        }

        .authentication-step {
            width: 660px;
            margin: 0 45px;
            padding-bottom: 50px;
            background-color: #FFF;
            border-radius: 38px;
            overflow: hidden;
            box-shadow: 0 2px 8px 0 rgba(233,233,233,1), 0 12px 16px 0 rgba(0, 0, 0, 0.05);
            position: relative;
            z-index: 1;
            top: 379px;
            .steps {
                padding: 0 70px;
                margin-top: 48px;
                .step-item {
                    line-height: 110px;
                    position: relative;

                    .custom-icon {
                        width: 50px;
                        height: 50px;
                        display: inline-block;
                        position: absolute;
                        left: 0;
                        top: 30px;
                        background-size: 100% 100%;
                        &.phone {
                            background-image: url(./images/icon_phone.png);
                        }
                        &.face {
                            background-image: url(./images/icon_face.png);
                        }
                        &.light {
                            background-image: url(./images/icon_light.png);
                        }
                        &.portrait {
                            background-image: url(./images/icon_portrait.png);
                        }
                    }

                    span {
                        margin-left: 80px;
                        font-family: 'PingFangSC-Regular';
                        font-weight: 400;
                        font-size: 28px;
                        color: #666;
                    }
                }
            }

            .start-authentication {
                width: 508px;
                margin: 0 auto;
            }
            .protocol-container {
              margin-top: 150px;
              padding: 30px;
              span {
                color:#8eb2d8
              }
            }
        }
    }
</style>
